import { RbacRole } from '@axilon-apps/domains-identity/constants'

/**
 * Each person gets one work page in the sidebar, chosen by role: plant
 * managers see Problems ("how is my plant doing?"), technicians and engineers
 * see Tasks ("what do I go do?"). Debug mode shows both.
 */
export type WorkPage = 'problems' | 'tasks'

export const WORK_PAGE_READ_PERMISSIONS: Readonly<Record<WorkPage, string>> = {
  problems: 'agents:custom:run/read',
  tasks: 'agents:custom:run/read'
}

// Holding any of these roles makes Tasks the work page, even alongside a
// manager role: an engineer who is also an org admin still has tasks to do.
const TASK_ROLES = new Set<string>([RbacRole.Operator, RbacRole.Maintenance, RbacRole.Engineer])

export function workPagesForRoles(roles: readonly string[], debugEnabled: boolean): WorkPage[] {
  if (debugEnabled) return ['problems', 'tasks']
  return roles.some((role) => TASK_ROLES.has(role)) ? ['tasks'] : ['problems']
}

/** Shared visibility for the sidebar and chat home; debug never bypasses read access. */
export function workPagesForAccess(
  roles: readonly string[],
  permissions: readonly string[],
  debugEnabled: boolean
): WorkPage[] {
  return workPagesForRoles(roles, debugEnabled).filter((page) =>
    permissions.includes(WORK_PAGE_READ_PERMISSIONS[page])
  )
}
